import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div style="text-align: justify;">
			
			<p class="mb-3">
				Kia bonŝanca mi estas!
			</p>
			
			<p class="mb-3">
				Hodiaŭ mi devis partopreni gravan kunsidon; kaj ĝuste unu horon antaŭ ĝia fino estis planita koncerto, 
				kiun mi tre deziris aŭskulti.
			</p>
			
			<p class="mb-3">
				Sed tagmeze eksonis aeralarmo, kaj la koncerto komenciĝis pli malfrue; ĝuste je la horo, 
				kiam mi fin-fine alproksimiĝis al la teatro. 
				Kia bonŝanco!
			</p>
			
			<p class="mb-3">
				Tamen, la koncerto okazis neinteresa kaj ne ekplaĉis al mi. 
				Certe, mi ĝenis foriri meze de la prezentado; sed denove eksonis sireno kaj ni ĉiuj estis elpelitaj al strato. 
				Kia bonŝanco!
			</p>
			
			<p class="mb-3">
				Do, mi ekiris hejmen, kie oni ĵus enŝaltis elektron, kiu estis forŝaltita la tutan tagon. 
			</p>
			
			<p class="mb-3">
				Kiel feliĉa, kiel bonŝanca mi estas! 
			</p>
			
		</div>

    `
  )
}

const itemName = {
  esp: 'Kia bonŝanca mi estas!',
  forLink: 'Kia bonŝanca mi estas'
}

const item = {
  itemlink: getLink(itemName.forLink),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}
export default item;